import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useState } from "react";
import {
  getWidthFromHeader,
  renderValueAsJSX,
} from "../../../until";
import "../styles.scss";
import { ListField } from "../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { ColumnKey } from "../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../CustomersV2/indexV2";
import FilterHeader from "./ServiceRecords/Components/FilterHeader";

const dataListFieldsByCustomerRecordActive = [
  {
    id: 99,
    title: "Thông tin hợp đồng",
    fields: [
      {
        id: 1,
        fieldCode: "model",
        fieldLabel: "Dòng xe",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 2,
        fieldCode: "brand",
        fieldLabel: "Số máy",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 3,
        fieldCode: "variant",
        fieldLabel: "Màu nội thất",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 4,
        fieldCode: "vehicle",
        fieldLabel: "Loại động cơ",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 5,
        fieldCode: "name",
        fieldLabel: "Ngày hợp đồng",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 6,
        fieldCode: "plate",
        fieldLabel: "Số hợp đồng",
        inputType: "text",
        isActive: 1,
      },
      {
        id: 7,
        fieldCode: "frame",
        fieldLabel: "Số hóa đơn",
        inputType: "text",
        isActive: 1,
      },
    ],
  },
];

const dataListFieldsByCustomerRecordNotActive = [
  { id: 99, title: "Thông tin hợp đồng", fields: [] },
];

const daumData = [
  {
    id: 1,
    code: "C53343401K1234",
    name: "Xe Đức - Du lịch",
    groupPermissionId: 100,
    fields: [
      { fieldId: 1, fieldLabel: "Model", fieldCode: "model", value: "Du lịch" },
      {
        fieldId: 2,
        fieldLabel: "Brand",
        fieldCode: "brand",
        value: "53343401K1234",
      },
      {
        fieldId: 3,
        fieldLabel: "Variant",
        fieldCode: "variant",
        value: "Trắng",
      },
      {
        fieldId: 4,
        fieldLabel: "Vehicle",
        fieldCode: "vehicle",
        value: "408 20G AT",
      },
      {
        fieldId: 5,
        fieldLabel: "Ngày mua",
        fieldCode: "name",
        value: "21/02/2022",
      },
      {
        fieldId: 6,
        fieldLabel: "Plate",
        fieldCode: "plate",
        value: "075/2025/HĐMB/KIAVL-KH",
      },
      {
        fieldId: 7,
        fieldLabel: "Frame",
        fieldCode: "frame",
        value: "00001226",
      },
    ],
    permissionMenu: {
      groupPermissionId: 100,
      view: true,
      edit: false,
      delete: false,
    },
  },
];

interface Prop {
  isSettingShow: boolean;
  activeServiceRecordsTab: string;
  setSettingShow: (isClose: boolean) => void;
}

const VehicleInformationyTabs = ({stData = {} as any}) => {
  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>(
    []
  );
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });

  useEffect(() => {
    gListFieldsActive();
  }, []);

  const gListFieldsActive = async () => {
    const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap(
      (choice) =>
        choice.fields.map((field) => ({ ...field, parentId: choice.id }))
    );
    setDataFilterActive(flattenedFields);
    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
  };

  const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
  ): ColDef[] => {
    const baseColumns = codes
      ?.map((code) => {
        const field = fields.find((f) => f.fieldCode === code);
        if (!field) return null;

        return {
          headerName: field.fieldLabel,
          headerComponent: FilterHeader,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          width: getWidthFromHeader(field.fieldLabel),
          cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode),
        } as ColDef;
      })
      .filter(Boolean) as ColDef[];

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
  };

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      columnsMapShow,
      dataFilterActive,
      undefined,
      (id: number, next: boolean, rowData: any) =>
        console.log(id, next, rowData)
    );
  }, [columnsMapShow, dataFilterActive]);

  const tableData = useMemo(() => {
    return daumData.map((item) => {
      const fieldValues = item.fields.reduce(
        (acc: Record<string, any>, field) => {
          acc[field.fieldCode] = field.value;
          return acc;
        },
        {}
      );

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      };
    });
  }, []);

  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFilterActive]);
  return (
    <>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css"
        style={{ width: "100%" }}
      >
        <AgGridReact
          rowData={stData.xesudung_show ? [stData.xesudung_show] : []}
          columnDefs={[
            { field: "own_chassis_no", headerName: "Số khung" },
            { field: "own_color_name", headerName: "Màu xe" },
            { field: "own_engine_no", headerName: "Số máy" },
            { field: "own_made_year", headerName: "Năm sản xuất" },
            { field: "own_number_plate", headerName: "Biển số" },
            { field: "own_purchase_date", headerName: "Ngày mua" },
            { field: "own_vehicle_model", headerName: "Mẫu xe" },
            { field: "own_vehicle_name", headerName: "Tên xe" },
            { field: "own_branch_name", headerName: "Đơn vị" },
            { field: "own_route_name", headerName: "Chi nhánh" },
          ]}
          rowHeight={55}
          domLayout="autoHeight"
          className="my-auto-height-grid w-100"
        />
      </div>
    </>
  );
};
export default VehicleInformationyTabs;
